import React from 'react';
import { Link } from 'react-router-dom';
export function TopBanner() {
  return <div className="bg-clean-grey text-slate-500 py-2 px-4 sm:px-6 lg:px-8 border-b border-slate-200 text-[9px] md:text-[10px] uppercase tracking-widest font-bold" data-id="element-290" data-mp="25yckq71kpnpl">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-center sm:justify-end items-center gap-2 sm:gap-6 text-center sm:text-left" data-id="element-291" data-mp="2ayh5wadff6m5">
        <a href="https://www.google.com/maps/dir/?api=1&destination=2002+Jennifer+Rd+Annapolis+MD+21401" target="_blank" rel="noopener noreferrer" className="hover:text-clinical-blue transition-colors" data-id="element-292" data-mp="1i9tbnpap96wg">
          Annapolis Pharmacy
        </a>
      </div>
    </div>;
}